import { Directive, inject, Input } from '@angular/core';
import { DtcApiService } from '../../../services/api/dtc-api.service';
import { BaseModal } from '../base/base-modal';
import { PropagationTargetOption } from '../../../../shared/models/sw-part-number/propagation-target-option';
import { ExecutionType } from './execution-type';
import { HotToastService } from '@ngxpert/hot-toast';

@Directive()
export abstract class PropagationModal extends BaseModal {
  @Input() public executionType = ExecutionType.Create;
  public callToActionDescription = 'Select the releases to which the changes should also be applied';
  public additionalInfoText?: string;

  protected propagationTargetOptions?: PropagationTargetOption[];
  protected entityId?: string;
  protected businessObject?: string;
  protected selectedOptionIds: string[] = [];

  protected readonly toast = inject(HotToastService);
  protected readonly dtcApi = inject(DtcApiService);

  protected toggleSelection(id?: string): void {
    if (!id) {
      return;
    }
    const index = this.selectedOptionIds.indexOf(id);
    if (index > -1) {
      this.selectedOptionIds.splice(index, 1);
    } else {
      this.selectedOptionIds.push(id);
    }
  }

  protected abstract execute(): void;
}
